import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useLocation, useParams } from 'react-router-dom';
import { EnderecoDTO } from '../../../shared/dto/enderecoDTO';
import { RegionalDTO } from '../../../shared/dto/regionalDTO';
import Spinner from '../../../shared/spinner';
import { Button } from 'react-bootstrap';
import RegionalService from '../../../services/regionalService';
import ViaCepService from '../../../services/viaCepService';
import CustomAlert from '../../../shared/customAlert';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import MatrizService from '../../../services/matrizService';
import { Matriz } from '../../../shared/model/matriz';

function RegionalInclusaoAlteracao() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  
  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();

  const [idMatriz, setIdMatriz] = useState('');
  const [matrizes, setMatrizes] = useState<Matriz[]>([]);

  const [nome, setNome] = useState('');
  const [emails, setEmails] = useState('');
  const [telefoneComercial, setTelefoneComercial] = useState('');
  const [telefoneCelular, setTelefoneCelular] = useState('');
  const [razaoSocial, setRazaoSocial] = useState('');

  // const [cep, setCep] = useState('');
  // const [logradouro, setLogradouro] = useState('');
  // const [numero, setNumero] = useState('');
  // const [complemento, setComplemento] = useState('');
  // const [bairro, setBairro] = useState('');
  // const [localidade, setLocalidade] = useState('');
  // const [uf, setUf] = useState('');

  const [codigoExterno, setCodigoExterno] = useState('');

  // --- NOVOS CAMPOS: DADOS BANCÁRIOS (CNAB 240) ---
  const [codigoBanco, setCodigoBanco] = useState('');
  const [nomeBanco, setNomeBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [digitoConta, setDigitoConta] = useState('');
  const [tipoConta, setTipoConta] = useState('CORRENTE');
  const [camaraCentralizadora, setCamaraCentralizadora] = useState('018'); // Default TED
  const [chavePix, setChavePix] = useState('');

  const [loading, setLoading] = useState(false);

  const regionalService: RegionalService = new RegionalService();
  const viaCepService: ViaCepService = new ViaCepService();
  const matrizService: MatrizService = new MatrizService();

  // Dicionário de explicações para formas de pagamento
  const explicacoesPagamento: { [key: string]: string } = {
    '018': 'TED (STR): Transferência Eletrônica Disponível convencional. Utilize para contas de bancos diferentes. O crédito geralmente ocorre no mesmo dia se enviado até o horário de corte (17h).',
    '000': 'Mesmo Banco (CC): Crédito em Conta Corrente. Utilize SOMENTE quando o banco de origem (pagador) for o mesmo do banco de destino (favorecido). Processamento mais rápido e sem custos de TED.',
    '009': 'PIX: Pagamento Instantâneo. Obrigatório informar a Chave PIX. Disponível 24/7.',
    '888': 'TED (CIP): Modalidade específica de TED via Câmara Interbancária de Pagamentos (menos comum que o STR 018).'
  };

  const listarMatrizesAtivas = async () => {
    try {
      const response = await matrizService.listarTodasMatrizesAtivas();
      setMatrizes(response.data);
      if (tipo === 'inclusao' && response.data.length > 0) {
        setIdMatriz(response.data[0].id!.toString());
      }
    } catch (err) {
      console.error(err);
    }
  };

  const listarRegionalPorId = async () => {
    setLoading(true);
    try {
      const response = await regionalService.listarRegionalPorId(id!);
      const jsonRegional = response.data;
      
      setIdMatriz(jsonRegional.idMatriz?.toString() || '');
      setNome(jsonRegional.nome);
      setRazaoSocial(jsonRegional.razaoSocial || '');
      setEmails(jsonRegional.email);
      setTelefoneComercial(jsonRegional.telefoneComercial || jsonRegional.foneComercial); 
      setTelefoneCelular(jsonRegional.telefoneCelular || jsonRegional.foneCelular);


      const end = jsonRegional.enderecoDTO || {}; 

      // setCep(end.cep || '');
      // setLogradouro(end.logradouro || ''); 
      // setNumero(end.numero || ''); 
      // setComplemento(end.complemento || '');
      // setBairro(end.bairro || '');
      // setLocalidade(end.localidade || ''); 
      // setUf(end.uf || '');

      setCodigoExterno(jsonRegional.codigoExterno);;

      // Dados Bancários
      setCodigoBanco(jsonRegional.codigoBanco || '');
      setNomeBanco(jsonRegional.nomeBanco || '');
      setAgencia(jsonRegional.agencia || '');
      setConta(jsonRegional.conta || '');
      setDigitoConta(jsonRegional.digitoConta || '');
      setTipoConta(jsonRegional.tipoConta || 'CORRENTE');
      setCamaraCentralizadora(jsonRegional.camaraCentralizadora || '018');
      setChavePix(jsonRegional.chavePix || '');

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };


  const handleSubmit = async (event: any) => {
      event.preventDefault();
      let endereco : EnderecoDTO = new EnderecoDTO();
      // endereco.cep = cep;
      // endereco.logradouro = logradouro;
      // endereco.numero = numero;
      // endereco.complemento = complemento;
      // endereco.bairro = bairro;
      // endereco.uf = uf;
      // endereco.localidade = localidade;
      
      // Utilizando 'any' para permitir a inclusão dos campos bancários
      let regionalDTO: any = new RegionalDTO();
      regionalDTO.idMatriz = idMatriz; 
      regionalDTO.id = id!;
      regionalDTO.nome = nome;
      regionalDTO.razaoSocial = razaoSocial;
      regionalDTO.email = emails;
      regionalDTO.enderecoDTO = endereco;
      regionalDTO.telefoneComercial = telefoneComercial;
      regionalDTO.telefoneCelular = telefoneCelular;
      regionalDTO.codigoExterno = codigoExterno;

      // Dados Bancários
      regionalDTO.codigoBanco = codigoBanco;
      regionalDTO.nomeBanco = nomeBanco;
      regionalDTO.agencia = agencia;
      regionalDTO.conta = conta;
      regionalDTO.digitoConta = digitoConta;
      regionalDTO.tipoConta = tipoConta;
      regionalDTO.camaraCentralizadora = camaraCentralizadora;
      regionalDTO.chavePix = chavePix;

      try {
        await regionalService.incluirAlterarRegional(regionalDTO!);
        setLoading(false);
        setAlert({ message: 'Regional salva com sucesso!', type: 'success' });
      } catch (err: any) {
        setLoading(false);
        setAlert({ message: err.response.data, type: 'error' });
        console.error(err);
      }
  };

  const limparCampos = () => {
    setNome('');
    setRazaoSocial('');
    setEmails('');
    setTelefoneComercial('');
    setTelefoneCelular('');
    // setCep('');
    // setLogradouro('');
    // setNumero('');
    // setComplemento('');
    // setBairro('');
    // setLocalidade('');
    // setUf('');
    setCodigoExterno('');

    // Limpar Bancários
    setCodigoBanco('');
    setNomeBanco('');
    setAgencia('');
    setConta('');
    setDigitoConta('');
    setTipoConta('CORRENTE');
    setCamaraCentralizadora('018');
    setChavePix('');
  }

  const viaCep = async (cep: string) => {
    if (cep !== undefined && cep !== '' && cep.length === 10) {
      setLoading(true);
      const cepWithoutMask = cep.replace(/\D/g, '');
      try {
        const response = await viaCepService.viaCep(cepWithoutMask);

        // const jsonViaCep = response.data;
        // setLogradouro(jsonViaCep.logradouro);
        // setLocalidade(jsonViaCep.localidade);
        // setUf(jsonViaCep.uf);
        // setBairro(jsonViaCep.bairro);

        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);
      }
    }
  };

  useEffect(() => {
      listarMatrizesAtivas(); 
    if (tipo === 'alteracao') {
      listarRegionalPorId();
    }
    
  }, []);

  return (
    <div className="container">
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={()=> { setAlert(null); if (alert.type === 'success') {window.history.back();} }} />)}
      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              {tipo === 'inclusao' ? <h5>Origens &gt; Regional &gt; Inclusão</h5> : (
                <h5>Origens &gt; Regional &gt; Alteração</h5>
              )}
              <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>

          <div className="row">
            <div className="col-xl">
             <label>Razão Social <span style={{ color: 'red' }}>*</span></label>
  <input 
    required 
    type="text" 
    className="form-control" 
    value={razaoSocial} 
    onChange={(e) => setRazaoSocial(e.target.value)} 
  />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-xl">
              <label>Matriz <span style={{ color: 'red' }}>*</span></label>
              <select required className="form-select" value={idMatriz} onChange={(e) => setIdMatriz(e.target.value)}>
                <option value="" disabled>Selecione uma Matriz</option>
                {matrizes.map((matriz) => (
                  <option key={matriz.id} value={matriz.id!}>
                    {matriz.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col-xl">
              <label>Nome da Regional <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
          </div>

          <div className="row">
            <div className="col-xl">
              <label>Lista de E-mails (separados por ';') <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={emails} onChange={(e) => setEmails(e.target.value)} />
            </div>
          </div>

          <hr className="my-4" />
          <h5 className="mb-3">Dados Bancários</h5>
          
          <div className="row">
            <div className="col-md-2">
              <label>Cód. Banco <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" placeholder="341" maxLength={3}
                value={codigoBanco} onChange={e => setCodigoBanco(e.target.value)} 
              />
            </div>
            <div className="col-md-4">
              <label>Nome do Banco</label>
              <input type="text" className="form-control" placeholder="Itaú Unibanco" 
                value={nomeBanco} onChange={e => setNomeBanco(e.target.value)} 
              />
            </div>
            <div className="col-md-2">
              <label>Agência (sem dígito)</label>
              <input type="text" className="form-control" maxLength={5}
                value={agencia} onChange={e => setAgencia(e.target.value)} 
              />
            </div>
            <div className="col-md-3">
              <label>Conta Corrente</label>
              <input type="text" className="form-control" maxLength={15}
                value={conta} onChange={e => setConta(e.target.value)} 
              />
            </div>
            <div className="col-md-1">
              <label>Dígito</label>
              <input type="text" className="form-control" maxLength={2}
                value={digitoConta} onChange={e => setDigitoConta(e.target.value)} 
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-2">
              <label>Tipo Conta</label>
              <select className="form-select" value={tipoConta} onChange={e => setTipoConta(e.target.value)}>
                <option value="CORRENTE">Corrente</option>
                <option value="POUPANCA">Poupança</option>
              </select>
            </div>
            <div className="col-md-4">
              <label>Forma de Pagamento <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" value={camaraCentralizadora} onChange={e => setCamaraCentralizadora(e.target.value)}>
                <option value="018">TED (STR)</option>
                <option value="000">Mesmo Banco (CC)</option>
                <option value="009">PIX</option>
                <option value="888">TED (CIP)</option>
              </select>
            </div>
            {camaraCentralizadora === '009' && (
              <div className="col-md-6">
                <label>Chave PIX <span style={{ color: 'red' }}>*</span></label>
                <input type="text" className="form-control" placeholder="Email, CPF/CNPJ, Celular ou Chave Aleatória"
                  value={chavePix} onChange={e => setChavePix(e.target.value)} 
                  required={camaraCentralizadora === '009'}
                />
              </div>
            )}
          </div>
          
          <div className="row mt-2">
            <div className="col-12">
              <div className="alert alert-info py-2 small mb-0">
                <strong><i className="bi bi-info-circle-fill me-2"></i>Informação:</strong> {explicacoesPagamento[camaraCentralizadora]}
              </div>
            </div>
          </div>
          
          {/* <div className="row">
            {loading ? <Spinner loading={loading} /> : false}
            <div className="col-md-2">
              <label>CEP <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="99.999-999" type="text" className="form-control" required
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                onBlur={(e) => viaCep(e.target.value)}
              />
            </div>
            <div className="col-md">
              <label>Endereço <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={logradouro} onChange={(e) => setLogradouro(e.target.value)} />
            </div>
            <div className="col-md-3">
              <label>Número <span style={{ color: 'red' }}>*</span></label>
              <input type="number" className="form-control" required value={numero} onChange={(e) => setNumero(e.target.value)} />
            </div>
          </div>

          <div className="row">
            <div className="col-md">
              <label>Bairro <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={bairro} onChange={(e) => setBairro(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Complemento</label>
              <input type="text" className="form-control" value={complemento} onChange={(e) => setComplemento(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Cidade <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" required value={localidade} onChange={(e) => setLocalidade(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Estado <span style={{ color: 'red' }}>*</span></label>
              <InputMask mask="aa" type="text" required className="form-control" value={uf} onChange={(e) => setUf(e.target.value.toUpperCase())} />
            </div>
          </div> */}

          <hr className="my-4" />

          <div className="row">
            <div className="col-md">
              <label className="form-label">Telefone Comercial <span style={{ color: 'red' }}>*</span></label>
              <div className="row">
                <div className="col-md">
                  <InputMask required mask="(99)9999-9999" type="text" className="form-control" value={telefoneComercial} onChange={(e) => setTelefoneComercial(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="col-md">
              <label className="form-label">Telefone Celular <span style={{ color: 'red' }}>*</span></label>
              <div className="row">
                <div className="col-md">
                  <InputMask required mask="(99)99999-9999" type="text" className="form-control" value={telefoneCelular} onChange={(e) => setTelefoneCelular(e.target.value)} />
                </div>
              </div>
            </div>
          </div>

          <hr className="my-4" />

          <div className="col-md">            
            <div className="row">
              <div className="col-md">
              <label>Código Externo</label>
              <input type="text" className="form-control" value={codigoExterno} onChange={(e) => setCodigoExterno(e.target.value)} />
              </div>
            </div>
          </div>

          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button onClick={limparCampos} className="w-40 btn btn-lg" id="App-button-cor-principal">Limpar Campos</button>
              <button className="w-40 btn btn-primary btn-lg btn btn-success" type="submit">{tipo !== 'inclusao' ? 'Alterar Regional' : 'Salvar Regional'}</button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default RegionalInclusaoAlteracao;